import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Button, Divider, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { ResponseObject } from "@/app/classes/main";
import { ApiService } from "@/app/services/AppService";

interface ToolTipSafetyInfoProps {
  openInfo: any;
  handleClose: any;
}

interface DisposableItems {
  heading: string;
  subHeading: string;
  items: string[];
  note: string;
}

const ToolTipSafetyInfo: React.FC<ToolTipSafetyInfoProps> = ({
  openInfo,
  handleClose,
}) => {
  const [disposableItems, setDisposableItems] =
    React.useState<DisposableItems>();
  const apiService = React.useMemo(() => new ApiService(), []);

  React.useEffect(() => {
    const fetchDisposableItems = async () => {
      try {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(apiService.disposableItems);
        setDisposableItems(responseObject?.object);
      } catch (error) {
        console.log("Error:", error);
      }
    };

    fetchDisposableItems();
  }, [apiService]);

  return (
    <React.Fragment>
      <Dialog
        open={openInfo}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
        sx={{
          zIndex: 10010,
        }}
      >
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              marginBottom: "1rem",
            }}
          >
            {disposableItems?.heading}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              marginBottom: "1rem",
            }}
          >
            {disposableItems?.subHeading}
          </Typography>
          {disposableItems?.items?.map((points: any, index: number) => (
            <Box sx={{ display: "flex" }} key={index}>
              <CheckIcon sx={{ color: "green", padding: "4px" }} />
              <Typography variant="body2">{points}</Typography>
            </Box>
          ))}
          <Typography
            variant="body2"
            sx={{
              marginTop: "1rem",
            }}
          >
            {disposableItems?.note}
          </Typography>
          <br />
          <Box
            sx={{
              textAlign: "end",
              width: "100%",
            }}
          >
            <Button
              variant="outlined"
              color="error"
              sx={{
                color: "red",
                borderRadius: "10rem",
                fontWeight: "600",
                textTransform: "capitalize",
              }}
              onClick={handleClose}
            >
              Close
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ToolTipSafetyInfo;
